import { apiSlice } from '../../api/api-slice';

import {
    CardsPersonageListRequest,
    CardsPersonageListResponse,
    CardsPersonageTitleData,
} from 'types/card/card-personage-list';

export const cardPersonageList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        personageList: builder.query<
            CardsPersonageListResponse,
            CardsPersonageListRequest
        >({
            query: (params) => ({
                url: '/personage/personage-list',
                method: 'GET',
                params,
            }),
        }),

        personageTitleList: builder.query<
            CardsPersonageTitleData[],
            string | void
        >({
            query: (cardSphereId?: string) => ({
                url: cardSphereId?.trim()
                    ? `/personage/personage-title-list?cardSphereId=${cardSphereId}`
                    : '/personage/personage-title-list',
                method: 'GET',
            }),
        }),
    }),
});

export const { useLazyPersonageListQuery, usePersonageTitleListQuery } =
    cardPersonageList;
